import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  IonContent,
  IonSlides,
  IonSlide,
  IonImg
} from '@ionic/react'
import { radioSections } from '../../../config/radioCategories'
import { appBasePath } from '../../../config/app'
import { NewsRadioCard } from '../../../components/common/NewsRadioCard'
import { NewsRadioCardSkeleton } from '../../../components/skeletons/NewsRadioCardSkeleton'
import { getContentFeed } from '../../../services/api/contents'

import './styles.scss'

const NoResults = () => {
  const [contents, SetContents] = useState([])

  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400
  }

  useEffect(() => {
    getContentFeed({
      limit: 12,
      category_id: [3, 6, 20],
      section: 'news'
    }).then((response) => {
      SetContents(response)
    }).catch(() => {
      SetContents([])
    })
  }, [])

  return (
    <IonContent
      fullscreen
      className='no-results page-wrapper'
    >
      <section className='notification'>
        <h1>
          No se encontraron resultados para su búsqueda
          <span role='img' aria-label='emoji sorprendido'> &#128551;</span>
        </h1>
        <IonImg
          src={`${appBasePath}/assets/images/notFound.png`}
          alt=''
        />
        <p>
          Puedes intentar de nuevo
          <span role='img' aria-label='emoji sonrisa de pena'> &#128556;</span>
        </p>
      </section>

      <section className='navigation'>
        <h2>
          Puedes hecharle un ojo a alguno de estos enlaces
          <span role='img' aria-label='emoji pensativo'> &#129300;</span>
        </h2>
        <div className='links'>
          <Link to='/' aria-label='Ir al inico'>Home</Link>
          <Link to='/news/1' aria-label='Ir a listado de news'>News</Link>
          <Link to='/podcast/explorar' aria-label='Explora todos los Podcast de Yok Radio'>Podcast</Link>
          {radioSections &&
            radioSections.radio.categories.detail.map((category) => (
              <Link
                key={category.id_category}
                to={`/${category.category_alias}/explorar`}
                aria-label={`Ver todos los programas de ${category.category}`}
              >
                {category.category}
              </Link>
            ))}
        </div>
      </section>

      <section className='news-swipper'>
        <h2>
          Tambien puedes leer alguna de estas
          <span role='img' aria-label='emoji anteojo de un ojo'> &#129488;</span>
        </h2>
        {contents.length > 0 &&
          <IonSlides pager options={slideOpts}>
            {contents.map((content) => (
              <IonSlide key={content.id}>
                <NewsRadioCard content={content} />
              </IonSlide>
            ))}
          </IonSlides>}

        {contents.length === 0 &&
          <IonSlides pager options={slideOpts}>
            <IonSlide>
              <NewsRadioCardSkeleton />
            </IonSlide>
            <IonSlide>
              <NewsRadioCardSkeleton />
            </IonSlide>
            <IonSlide>
              <NewsRadioCardSkeleton />
            </IonSlide>
          </IonSlides>}
      </section>
    </IonContent>
  )
}

export default NoResults
